// extracted by mini-css-extract-plugin
export default {"productDescription":"Lda-z","featuredDescription":"Mda-z","description":"Nda-z","more":"Oda-z","descriptionSku":"Pda-z"};